<template>
  <div class="d-flex flex-column align-center pt-10">
    <v-icon size="150"
            color="disabled"
            v-text="preFilledIcon" />
    <h2 class="mt-3 px-4 useThemeTextColor"
        v-text="preFilledTitle" />
    <p class="pa-3 helptext"
       v-text="preFilledMessage" />
    <slot name="actions">
    </slot>
  </div>
</template>

<script>
export default {
  props: ["icon", "title", "message"],
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {
    preFilledIcon() {
      if (this.icon) {
        return this.icon;
      } else {
        return "mdi-progress-question";
      }
    },
    preFilledTitle() {
      if (this.title) {
        return this.title;
      } else if (this.title === false) {
        return "";
      } else {
        return "No elements found.";
      }
    },
    preFilledMessage() {
      if (this.message) {
        return this.message;
      } else if (this.message === false) {
        return "";
      } else {
        return "We could not find any elements matching your spesifications.";
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.helptext {
  max-width: 400px;
}
</style>
